import { render, staticRenderFns } from "./FacilityExtraPricing.vue?vue&type=template&id=3705e091&scoped=true"
import script from "./FacilityExtraPricing.vue?vue&type=script&lang=js"
export * from "./FacilityExtraPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705e091",
  null
  
)

export default component.exports